let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("VyTfa")).then(() => parcelRequire('9t16h'));